/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */
import axios from 'axios';
import { t } from 'i18next';
import React, { useEffect, useReducer, useState, useLayoutEffect } from 'react';
import { Container, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import { useSelector } from 'react-redux';
import {
  GET_COUNTRY_LIST,
  GET_EMIRATES_LIST,
  POST_FORM_DATA,
  POST_SET_GETSUITABLE_TIME_LIST,
  POST_SET_GETWORK_TYPE_LIST,
  POST_SET_PROFFESSSION_LIST,
  SET_COUNTRIES,
  SET_DATA,
  SET_EMIRATES,
  SET_GETSUITABLE_TIME_LIST,
  SET_GETWORK_TYPE_LIST,
  SET_PROFFESSSION_LIST,
  initialState,
  reducer,
} from '../../../features/FormReducers/GlobalFormFeatures';
import useFetchAndDispatch from '../../../hooks/useFetchAndDispatch/useFetchAndDispatch';
import Userbanner from '../../../components/elements/Userbanner';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';

const VolunteerRegistration = ({ setDataSubmit }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [countryCheck, setCountryCheck] = useState(0);
  const [userData, setuserData] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [landLine, setLandLine] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [formField, setFormField] = useState({
    skills: '',
    landline: landLine,
    weekDaysName: [],
  });

  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const { pathname } = useLocation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setLandLine(value);
      // setFormField((prev) => ({
      //   ...prev,
      //   [name]: value,
      // }));
    }
  };
  // Convert the ids to integers and submit the form data
  const onSubmit = (formData) => {
    // Destructure the formData object
    const headersList = {
      Authorization: `Bearer ${token}`,
    };
    const { countryID, emiratesID, professionID, skills, suitableTimeID, weekDaysName, workTypeID } = formData;
    // Convert the weekDaysName values to an array of integers
    const convertedWeekDays = weekDaysName.map((day) => Number(day));

    const data = {
      epUserID: epUserID,
      countryID: state?.countries[0]?.countryID,
      emiratesID: Number(emiratesID) || 0,
      landLine: landLine,
      professionID: Number(professionID),
      skills: skills,
      suitableTimeID: Number(suitableTimeID),
      weekDaysName: convertedWeekDays,
      workTypeID: Number(workTypeID),
    };

    if (data) {
      setIsLoad(true);
      axios.post(POST_FORM_DATA, data, { headers: headersList }).then((response) => {
        setIsLoad(false);
        toast.success(t('Registration successful.'));
        dispatch({ type: SET_DATA, payload: response.data });
        setDataSubmit(true);
        navigate('/volunteerlist');
        reset();
      });
    } else {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  // Use the custom hook for each API call
  useFetchAndDispatch('GET', GET_COUNTRY_LIST, SET_COUNTRIES, dispatch);
  useFetchAndDispatch('GET', GET_EMIRATES_LIST, SET_EMIRATES, dispatch);
  useFetchAndDispatch('POST', POST_SET_PROFFESSSION_LIST, SET_PROFFESSSION_LIST, dispatch);
  useFetchAndDispatch('POST', POST_SET_GETSUITABLE_TIME_LIST, SET_GETSUITABLE_TIME_LIST, dispatch);
  useFetchAndDispatch('POST', POST_SET_GETWORK_TYPE_LIST, SET_GETWORK_TYPE_LIST, dispatch);

  const weekDaysSelect = {
    id: 9,
    label: 'Week Day',
    type: 'checkbox',
    validation: { required: true },
    name: 'weekDaysName', // Update this to match the form data
    placeholder: 'Week Day',
    options: [
      { label: 'Sunday', value: 1 },
      { label: 'Monday', value: 2 },
      { label: 'Tuesday', value: 3 },
      { label: 'Wednesday', value: 4 },
      { label: 'Thursday', value: 5 },
      { label: 'Friday', value: 6 },
      { label: 'Saturday', value: 7 },
    ],
    value: [],
    disabled: true,
  };

  const onChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormField((prev) => {
      if (type === 'checkbox') {
        const intValue = parseInt(value, 10);

        if (!isNaN(intValue)) {
          const updatedState = checked ? [...prev[name], intValue] : prev[name].filter((day) => day !== intValue);

          return {
            ...prev,
            [name]: updatedState.length > 0 ? updatedState : [],
          };
        }
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }

      return prev; // Default case, if no changes are made
    });
  };

  const getEPUserData = async () => {
    setIsLoad(true);
    await getAsync('EP_UserAuthentication/EPUserByID/', {
      id: epUserID,
    })
      .then((response) => {
        setIsLoad(false);
        if (response != null) {
          const result = response?.data[0];
          setuserData(result);
        } else {
          toast.error(t('Something went wrong, Please try again!'));
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log(t('Something went wrong, Please try again!'));
      });
    if (epUserID !== null) {
      getEPUserData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);
  useLayoutEffect(() => {
    const getEPService = async () => {
      setIsLoad(true);
      try {
        const res = await postAsync('Utilities/EPUserServiceCheck', {}, { id: epUserID });
        if (res?.gwaServiceRegistered != 0) {
          navigate('/volunteerlist');
        }
        setIsLoad(false);
      } catch (error) {
        setIsLoad(false);
        console.error('Error updating data:', error);
      }
    };
    if (epUserID !== null) {
      getEPService();
    }
  }, []);

  return (
    <>
      {/* <Userbanner /> */}
      <div className="pt-12">
        <Userbanner />
        <Container className=" py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row ">
              <div className="my-2 pb-3">
                <h1 className="text-2xl text-customgreen text-center font-bold ">{t('Volunteer Registration')}</h1>
              </div>

              <div className="col-md-6 col-lg-4 ">
                <div className="form-group">
                  <label>{t('Full Name')}</label>
                  <input
                    type="text"
                    value={userData?.fullName}
                    disabled
                    style={{
                      cursor: 'no-drop',
                      fontWeight: '600',
                    }}
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-4 ">
                <div className="form-group">
                  <label>{t('Mobile Number')}</label>
                  <input
                    type="text"
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                    disabled
                    value={userData?.mobile}
                    style={{
                      cursor: 'no-drop',
                      fontWeight: '600',
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-4 ">
                <div className="form-group">
                  <label>{t('Email')}</label>
                  <input
                    type="text"
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                    disabled
                    value={userData?.email}
                    style={{
                      cursor: 'no-drop',
                      fontWeight: '600',
                    }}
                  />
                </div>
              </div>

              <div className="col-md-6 col-lg-4 ">
                <div controlId="skills">
                  <label>{t('Skill')}</label>
                  <Form.Control
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                    type="text"
                    placeholder={t('Enter Skills')}
                    {...register('skills', { required: true })}
                  />
                  {errors.skills && (
                    <Form.Control.Feedback type="invalid">{t('Please enter skills')}</Form.Control.Feedback>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-lg-4 ">
                <div className=" " controlId="landLine">
                  <label>{t('Land Line')}</label>
                  <input
                    placeholder={t('Enter Land Line')}
                    className={` w-full ${isActive ? 'text-end' : 'text-start'}   border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block`}
                    type="text"
                    min="0"
                    value={landLine}
                    onChange={handleInputChange}
                    //{...register('landLine', { required: true })}
                  />
                  {errors.landLine && (
                    <Form.Text className="text-muted" style={{ color: 'red' }}>
                      {t('This field is required')}
                    </Form.Text>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-lg-4 " controlId="professionID">
                <label>{t('Profession')}</label>
                <select
                  className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                  {...register('professionID', { required: true })}
                >
                  <option value="">{t('Select Profession')}</option>
                  {state.professionList.map((profession) => (
                    <option key={profession.professionID} value={profession.professionID}>
                      {isActive ? profession?.ar_Sa : profession?.en_Us}
                    </option>
                  ))}
                </select>
                {errors.professionID && <Form.Text className="text-muted">{t('This field is required')}</Form.Text>}
              </div>

              <div className="col-md-6 col-lg-4 ">
                <div controlId="countryID">
                  <label>{t('Country')}</label>
                  <input
                    disabled="true"
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                    type="text"
                    // {...register('countryID', { required: true })}
                    value={state.countries[0]?.countryName}
                    // onChange={(e) => {
                    //   setCountryCheck(e.target.value);
                    // }}
                  />

                  {errors.countryID && <Form.Text className="text-muted">{t('This field is required')}</Form.Text>}
                </div>
              </div>
              {true && (
                <div className="col-md-6  col-lg-4 ">
                  <div controlId="emiratesID">
                    <label>{t('Emirates')}</label>
                    <select
                      className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                      as="select"
                      {...register('emiratesID', { required: true })}
                      value={state.data.emiratesID}
                    >
                      <option value="">{t('SELECT EMIRATES')}</option>
                      {state.emirates.map((emirates) => (
                        <option key={emirates.emiratesID} value={emirates.emiratesID}>
                          {isActive ? emirates?.ar_SA : emirates.en_US}
                        </option>
                      ))}
                    </select>
                    {errors.emiratesID && <Form.Text className="text-muted">{t('This field is required')}</Form.Text>}
                  </div>
                </div>
              )}
              <div className="col-md-6 col-lg-4 ">
                <div controlId="workTypeID">
                  <label>{t('Work Type')}</label>
                  <select
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                    as="select"
                    {...register('workTypeID', { required: true })}
                    value={state.data.workTypeID}
                  >
                    <option value="">{t('Select Work Type')}</option>
                    {state.getWorkTypeList.map((workType) => (
                      <option key={workType.workTypeID} value={workType.workTypeID}>
                        {t(workType.en_Us)}
                      </option>
                    ))}
                  </select>
                  {errors.workTypeID && <Form.Text className="text-muted">{t('This field is required')}</Form.Text>}
                </div>
              </div>
              <div className="col-md-6 col-lg-4 ">
                <div controlId="suitableTimeID">
                  <label>{t('Suitable Time')}</label>
                  <select
                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                    as="select"
                    {...register('suitableTimeID', { required: true })}
                  >
                    <option value="">{t('Select suitable time')}</option>
                    {state.getSuitableTimeList.map((suitableTime) => (
                      <option key={suitableTime.suitableTimeID} value={suitableTime.suitableTimeID}>
                        {t(suitableTime.en_Us)}
                      </option>
                    ))}
                  </select>
                  {errors.suitableTimeID && <Form.Text className="text-muted">{t('This field is required')}</Form.Text>}
                </div>
              </div>
            </div>

            {/* <div className="row pb-56 sm:pb-0 my-2">
              <div className=" md:flex">
                <div className="" controlId="weekDaysName">
                  <label className="my-2">{t('Week Day')}</label>
                  <Form.Check
                    className=" md:flex justify-start items-start gap-2"
                    key={weekDaysSelect.id}
                    type={weekDaysSelect.type}
                    label={weekDaysSelect.label}
                    {...register(weekDaysSelect.name, weekDaysSelect.validation)}
                    value={weekDaysSelect.value}
                    disabled={weekDaysSelect.disabled}
                  >
                    {weekDaysSelect.options.map((option) => (
                      <Form.Check
                        class="  mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium  text-sm"
                        key={option.value}
                        type={weekDaysSelect.type}
                        label={t(`${option.label}`)}
                        value={option.value}
                        {...register(weekDaysSelect.name, weekDaysSelect.validation)}
                      />
                    ))}
                  </Form.Check>
                  {errors.weekDaysName && <Form.Text className="text-muted">{t('This field is required')}</Form.Text>}
                </div>
              </div>
              <button
                variant="primary"
                type="submit"
                className="text-white w-32  m-2 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
              >
                {t('Submit')}
              </button>
            </div> */}

            <div className="row  my-2">
              <div className=" md:flex flex justify-center">
                <div className="md:col  justify-center items-start gap-2" controlId="weekDaysName">
                  <div className="flex justify-center">
                    <label className="my-2 text-2xl text-customgreen font-black">{t('Week Days')}</label>
                  </div>

                  <div className=" flex flex-wrap md:flex-row px-2 gap-2 justify-center">
                    {weekDaysSelect.options.map(
                      (option) =>
                        // <Form.Check
                        //   className="   flex-row ml-5 p-1  my-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium text-sm"
                        //   key={option.value}
                        //   type={weekDaysSelect.type}
                        //   label={`${t(option.label)}`}
                        //   value={option.value}
                        //   name={weekDaysSelect.name}
                        //   {...register('weekDaysName')}
                        //   checked={formField.weekDaysName?.includes(option.value)}
                        //   onChange={onChange}
                        // />

                        // new code for check box

                        isActive ? (
                          <>
                            <div className="my-2 gap-2">
                              <input
                                className=" "
                                option={option}
                                id={`check-api-${option.value}`}
                                value={option.value}
                                name={weekDaysSelect.name}
                                {...register('weekDaysName')}
                                checked={formField.weekDaysName?.includes(option.value)}
                                onChange={onChange}
                                type={weekDaysSelect.type}
                                type="checkbox"
                                className="peer relative h-5 w-5 cursor-pointer focus:ring-4 focus:ring-customgreen appearance-none rounded-md border border-customgreen transition-all
      before:content[''] before:absolute before:top-2/4 before:left-2/4 before:block before:h-5 before:w-5 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-customgreen before:opacity-0 before:transition-opacity
      checked:border-none checked:bg-customgreen checked:before:bg-white hover:before:opacity-10"
                                id="check"
                              />
                              <label className={` mr-3 font-bold`}>{`${t(option.label)}`}</label>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="my-2 gap-2">
                              <input
                                className="mx-2 "
                                option={option}
                                id={`check-api-${option.value}`}
                                value={option.value}
                                name={weekDaysSelect.name}
                                {...register('weekDaysName')}
                                checked={formField.weekDaysName?.includes(option.value)}
                                onChange={onChange}
                                type={weekDaysSelect.type}
                                type="checkbox"
                                className="peer relative h-5 w-5 cursor-pointer focus:ring-4 focus:ring-customgreen appearance-none rounded-md border border-customgreen transition-all
      before:content[''] before:absolute before:top-2/4 before:left-2/4 before:block before:h-5 before:w-5 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-customgreen before:opacity-0 before:transition-opacity
      checked:border-none checked:bg-customgreen checked:before:bg-white hover:before:opacity-10"
                                id="check"
                              />
                              <label className={` ml-3  font-bold`}>{`${t(option.label)}`}</label>
                            </div>
                          </>
                        ),

                      // new code for check box
                    )}
                  </div>
                  {errors.weekDaysName && <Form.Text className="text-muted">{t('This field is required.')}</Form.Text>}
                </div>
              </div>
              <div className="px-3 my-2 flex justify-center">
                <button
                  type="submit"
                  className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                >
                  {' '}
                  {t('Submit')}
                </button>
              </div>
            </div>
          </form>
        </Container>
      </div>
    </>
  );
};

export default VolunteerRegistration;
